const FALLBACK_MONTHLY_PRICE = 9999;

exports = module.exports = {
    FALLBACK_MONTHLY_PRICE
}